import { useEffect, useState } from 'react'
import { breakpoint } from '../__styling'

export function useIsTabletOrMobileViewport() {
    const [isTabletOrMoblie, setIsTabletOrMoblie] = useState(false)

    const updateTabletOrMobile = () => {
        if (
            // fail conditional if SSR is triggered or a VR test
            typeof window !== 'undefined' &&
            window &&
            typeof window.matchMedia === 'function'
        ) {
            const mdBreakpoint = window.matchMedia(
                breakpoint('md').replace('@media ', ''),
            )
            // if viewport size is below md breakpoint return true
            if (!mdBreakpoint.matches) {
                return setIsTabletOrMoblie(true)
            }
        }
        return setIsTabletOrMoblie(false)
    }

    useEffect(() => {
        updateTabletOrMobile()
    }, [])

    useEffect(() => {
        window.addEventListener('resize', updateTabletOrMobile)
        return () => window.removeEventListener('resize', updateTabletOrMobile)
    })

    return isTabletOrMoblie
}
